export default __webpack_public_path__ + "assets/img/logo.767e0d268fde3e654a5017c8e0fe2815.png";